export default __webpack_public_path__ + "static/media/image19.2d313196.png";